import { uz } from './locales/uz.js';
import { en } from './locales/en.js';
import { ru } from './locales/ru.js';
import type { Locale, LocaleInfo, Translations } from './types.js';

export * from './types.js';

export const DEFAULT_LOCALE: Locale = 'uz';

export const SUPPORTED_LOCALES: LocaleInfo[] = [
  { code: 'uz', label: 'UZ', nativeName: "O'zbekcha", flag: '🇺🇿' },
  { code: 'en', label: 'EN', nativeName: 'English', flag: '🇬🇧' },
  { code: 'ru', label: 'RU', nativeName: 'Русский', flag: '🇷🇺' },
];

export const translations: Record<Locale, Translations> = {
  uz,
  en,
  ru,
};

/**
 * Nested key accessor using dot notation (e.g. 'nav.overview', 'login.title')
 */
export function getTranslation(locale: Locale, key: string): string {
  const currentDict = translations[locale] || translations[DEFAULT_LOCALE];
  const keys = key.split('.');

  let current: any = currentDict;
  for (const part of keys) {
    if (current && typeof current === 'object' && part in current) {
      current = current[part];
    } else {
      // Fallback to default locale (uz) or key itself
      let fallback: any = translations[DEFAULT_LOCALE];
      for (const fallbackPart of keys) {
        if (fallback && typeof fallback === 'object' && fallbackPart in fallback) {
          fallback = fallback[fallbackPart];
        } else {
          return key;
        }
      }
      return typeof fallback === 'string' ? fallback : key;
    }
  }

  return typeof current === 'string' ? current : key;
}
